import * as React from 'react';

import classnames from 'classnames';

import {Button} from 'shells/button/button';
import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {GridList} from 'shells/grid-list/grid-list';
import {Illustration} from 'shells/illustrations/illustration';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {OptionCardChooser} from 'shells/option-card-chooser/option-card-chooser';

import type {GetWebFormStarters_webFormStarters as FormStarter} from 'nutshell-graphql-types';

import styles from './form-starters-grid.module.css';

type Props = {
    formStarters: FormStarter[];
    isLoading: boolean;
    onStartFromScratch: () => void;
    setSelectedStarterFormId: (id: string) => void;
};

export function FormStartersGrid(props: Props) {
    return (
        <div className={styles.container}>
            {props.isLoading ? <LoadingPage /> : undefined}
            {!props.isLoading && !props.formStarters.length ? (
                <div
                    className={classnames(
                        'full-height full-width flex justify-center',
                        styles['empty-state-container']
                    )}
                >
                    <EmptyStateSmall
                        title=''
                        subtitle='We weren’t able to find any form templates! Start from scratch to create your first form.'
                        cta={
                            <Button
                                variant='primary'
                                size='big'
                                onClick={() => {
                                    props.onStartFromScratch();
                                }}
                            >
                                Create a form from scratch
                            </Button>
                        }
                        icon={
                            <div style={{width: 120, height: 120}}>
                                <Illustration
                                    src='magnifying-glass-empty-state'
                                    width='100%'
                                    height='100%'
                                />
                            </div>
                        }
                    />
                </div>
            ) : (
                <div className={styles['grid-container']}>
                    <GridList numColumns={2}>
                        {props.formStarters.map((starter) => {
                            let illustrationName = 'join-mailing-list';

                            switch (starter.id) {
                                case '8-WebFormStarters':
                                    illustrationName = 'contact-us';
                                    break;
                                case '12-WebFormStarters':
                                    illustrationName = 'content-download';
                                    break;
                                case '16-WebFormStarters':
                                    illustrationName = 'sales-request';
                                    break;
                                case '20-WebFormStarters':
                                    illustrationName = 'join-mailing-list';
                                    break;
                            }

                            return (
                                <OptionCardChooser
                                    key={starter.id}
                                    title={starter.name}
                                    subtitle={starter.description || ''}
                                    // TODO update with correct illustrations
                                    illustration={illustrationName}
                                    onClick={() => {
                                        props.setSelectedStarterFormId(starter.id);
                                    }}
                                />
                            );
                        })}
                    </GridList>
                </div>
            )}
        </div>
    );
}
